import React, { useState, useEffect, useCallback } from "react";
import {
  Form,
  DatePicker,
  Input,
  notification,
  Button,
  Select,
  Col,
  Row,
  Switch,
} from "antd";
import CurrencyInput from "react-currency-input";
import { PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import { odata } from "../Filters/Helper";
import RequestHandler from "../../util/RequestHandler";
const { Option } = Select;
const dateFormat = "DD/MM/YYYY";
const layout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 18,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};
const { TextArea } = Input;
const CheckPromissoryUpdate = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [MonthlyPlanTypeId, setMonthlyPlanTypeId] = useState(
    props.MonthlyPlanTypeId
  );
  const [CurrencyCode, setCurrencyCode] = useState(props.CurrencyCode);
  const [Amount, setAmount] = useState(props.Amount);
  const [TransactionDate, setTransactionDate] = useState(props.TransactionDate);
  const [Description, setDescription] = useState(props.Description);
  const [changeAll, setChangeAll] = useState(props.changeAll);
  const [teminatDropdown, setteminatDropdown] = useState([]);
  const [currencyDropdown, setcurrencyDropdown] = useState([]);
  const [ManualTransactionTypeDropdown, setManualTransactionTypeDropdown] =
    useState([]);
  const [OtherTransactionProcessType, setOtherTransactionProcessType] =
    useState([]);

  const [checkPlan, setCheckPlan] = useState(false);
  const [bankId, setbankId] = useState("");
  const [bankBranchCode, setBankBranchCode] = useState(props.bankBranchCode);
  const [bankBranchId, setBankBranchId] = useState("");
  const [bankDropdown, setbankDropdown] = useState([]);
  const [selectedBankDropdown, setSelectedBankDropdown] = useState([]);
  const [bankBranchDropdown, setbankBranchDropdown] = useState([]);
  const [paymentPlace, setPaymentPlace] = useState(props.paymentPlace);
  const [serialNo, setSerialNo] = useState(props.serialNo);
  const [Vkn, setVkn] = useState("");
  const [tahsilatButton, setTahsilatButton] = useState(false);
  const [odemeButton, setOdemeButton] = useState(false);
  const [salesmanCode, setSalesmanCode] = useState({
    data: [],
    loading: true,
  });

  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const [FirmId, setFirmId] = useState(props.firmId);
  const [isCompleted, setIsCompleted] = useState(props.isCompleted);

  const onChangeFirm = (value) => {
    RequestHandler.get(`/Firm/GetById/${value}`).then((response) => {
      if (response.vkn !== null) {
        form.setFieldsValue({ Vkn: response.vkn });
      } else if (response.vkn === null && response.tcNo !== null) {
        form.setFieldsValue({ Vkn: response.tcNo });
      } else {
        form.setFieldsValue({ Vkn: "" });
      }
    });
  };

  useEffect(() => {
    RequestHandler.get(`/Bank`).then((response) => {
      setbankDropdown(
        response.value.filter((x) => x.isSupportAccountTransaction === true)
      );
      setSelectedBankDropdown(
        response.value.filter((x) => x.id === props.bankId)
      );
    });
    RequestHandler.get(`/MonthlyPlanType`).then((response) => {
      setManualTransactionTypeDropdown(response.value);
    });
    getSalesmanCode();
  }, []);

  const getSalesmanCode = () => {
    setSalesmanCode({
      ...salesmanCode,
      loading: true,
    });
    RequestHandler.get(`/ErpLogo/GetSalesmanCodes`, [], false, {
      rawResponse: true,
    }).then((response) => {
      if (response != "") {
        setSalesmanCode({
          data: response,
          loading: false,
        });
      } else {
        setSalesmanCode({
          data: [],
          loading: false,
        });
      }
    });
  };

  useEffect(() => {
    RequestHandler.get(`/Types/GetManualTransactionTypes`).then((response) => {
      setteminatDropdown(response);
    });

    RequestHandler.get(`/Currency`).then((response) => {
      setcurrencyDropdown(response.value);
    });
    setMonthlyPlanTypeId(props.MonthlyPlanTypeId);
    //setteminatDropdown(props.teminatDropdown);
    setDescription(props.Description);
    setCheckPlan(props.checkPlan);
    setbankId(props.bankId);
    setbankDropdown(props.bankDropdown);
    setBankBranchCode(props.bankBranchCode);
    setPaymentPlace(props.paymentPlace);
    setSerialNo(props.serialNo);
    setVkn(props.Vkn);
    setTransactionDate(props.TransactionDate);
    setChangeAll(props.changeAll);
    setAmount(props.Amount);
    setCurrencyCode(props.CurrencyCode);
    setOtherTransactionProcessType(props.OtherTransactionProcessType);
    setIsCompleted(props.isCompleted);
  }, [
    setOtherTransactionProcessType,
    setteminatDropdown,
    setChangeAll,
    setMonthlyPlanTypeId,
    setCurrencyCode,
    setAmount,
    setTransactionDate,
    setDescription,
    setCheckPlan,
    setbankId,
    setbankDropdown,
    setPaymentPlace,
    setSerialNo,
    setBankBranchCode,
    setVkn,
    props.changeAll,

    props.teminatDropdown,
    props.OtherTransactionProcessType,
    props.MonthlyPlanTypeId,
    props.CurrencyCode,
    props.Amount,
    props.TransactionDate,
    props.Description,
    props.paymentPlace,
    props.serialNo,
    props.bankId,
    props.bankDropdown,
    props.bankBranchCode,
    props.Vkn,
  ]);

  useEffect(() => {
    if (props.firmId) {
      setFirmSelect({
        ...firmSelect,
        loading: true,
      });
      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name,tcNo,vkn&$filter=id eq ${props.firmId}`
      ).then((response) => {
        setFirmSelect({
          data: response.value,
          loading: false,
        });

        if (response.value[0].vkn !== null) {
          form.setFieldsValue({ Vkn: response.value[0].vkn });
        } else if (
          response.value[0].vkn === null &&
          response.value[0].tcNo !== null
        ) {
          form.setFieldsValue({ Vkn: response.value[0].tcNo });
        } else {
          form.setFieldsValue({ Vkn: "" });
        }
      });
    }
  }, []);

  const onChangeBankId = (e) => {
    setbankId(e);
  };
  const onChangeBankBranchCode = (e) => {
    setBankBranchCode(e.target.value);
  };

  const changeButton = (val) => {
    if (val === "1") {
      setTahsilatButton(true);
      setOdemeButton(false);
    } else if (val === "2") {
      setOdemeButton(true);
      setTahsilatButton(false);
    }
  };

  const onChangeOtherTransactionProcessTypeValue = (e) => {
    setOtherTransactionProcessType(e);
  };
  const onChangeMonthlyPlanValue = (e) => {
    setMonthlyPlanTypeId(e);
  };
  const onChangeAmount = (e) => {
    setAmount(e);
  };
  const onChangeFirmId = (e) => {
    setFirmId(e);
    RequestHandler.get(`/Firm/GetById/${e}`).then((response) => {
      if (response.vkn !== null) {
        form.setFieldsValue({ Vkn: response.vkn });
      } else if (response.vkn === null && response.tcNo !== null) {
        form.setFieldsValue({ Vkn: response.tcNo });
      } else {
        form.setFieldsValue({ Vkn: "" });
      }
    });
  };
  const onChangeCurrencyValue = (e) => {
    setCurrencyCode(e);
  };
  const onChangePaymentPlace = (e) => {
    setPaymentPlace(e.target.value);
  };
  const onChangeSerialNo = (e) => {
    setSerialNo(e.target.value);
  };
  const onChangeDateValue = (e) => {
    if (e !== null) {
      setTransactionDate(e);
    }
  };
  const onChangeVkn = (e) => {
    setVkn(e.target.value);
  };
  const onChangeDescriptionValue = (e) => {
    setDescription(e.target.value);
  };
  const onChangeCheck = (val) => {
    setCheckPlan(val);
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });
      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onFinishUpdate = (values) => {
    var amountString = values.Amount.toString();
    if (amountString.includes(".")) {
      if (amountString.includes(",")) {
      } else {
        amountString = amountString.replace(".", ",");
      }
    }

    RequestHandler.put(
      `/CheckPromissory`,
      {
        Id: props.monthlyPlanId,
        MonthlyPlanTypeId: values.MonthlyPlanTypeId,
        OtherTransactionProcessType: values.OtherTransactionProcessType,
        CurrencyId: values.CurrencyCode,
        Amount: 1,
        IsChangeAll: changeAll,
        AmountString: amountString,
        Description: values.Description,
        TransactionDate: values.TransactionDate.format("YYYY-MM-DD"),
        FirmId: values.firmId,
        MainType: 1,
        PaymentPlace: values.PaymentPlace,
        SerialNo: values.SerialNo,
        Vkn: values.Vkn,
        bankId: bankId,
        BankName: values.bankName,
        BankBranchCode: values.BankBranchCode,
        SalesmanCode: values.salesmanCode,
        isCompleted: values.isCompleted,
      },
      false,
      { rawResponse: true }
    )
      .then((res) => {
        if (res.status == 200) {
          openNotificationWithIconUpdate("success");
          setTimeout(
            function () {
              props.sendCheckDataForUpdate("success");
              setLoading(false);
            }.bind(this),
            2000
          );
        } else {
          setLoading(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const onFinishFailedUpdate = () => setLoading(false);
  const openNotificationWithIconUpdate = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Güncelleme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  return (
    <div>
      <Form
        {...layout}
        form={form}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinishUpdate}
        onFinishFailed={onFinishFailedUpdate}
        fields={[
          {
            name: "OtherTransactionProcessType",
            value: OtherTransactionProcessType,
          },
          { name: "MonthlyPlanTypeId", value: MonthlyPlanTypeId },
          { name: "CurrencyCode", value: CurrencyCode },
          { name: "Amount", value: Amount },
          {
            name: "TransactionDate",
            value: moment(TransactionDate, dateFormat),
          },
          { name: "firmId", value: FirmId },
          { name: "BankId", value: bankId },
          { name: "PaymentPlace", value: paymentPlace },
          { name: "SerialNo", value: serialNo },
          { name: "BankBranchCode", value: bankBranchCode },
        ]}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              label="Ödeme/Tahsilat Tipi "
              style={{ marginTop: "4%" }}
              name="OtherTransactionProcessType"
              rules={[
                {
                  required: true,
                  message: "Lütfen Ödeme/Tahsilat tipi alanını boş bırakmayın.",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Ödeme/Tahsilat tipi seçiniz"
                optionFilterProp="children"
                onChange={onChangeOtherTransactionProcessTypeValue}
                filterOption={(input, option) =>
                  option.props.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
              >
                {teminatDropdown.map((item) => (
                  <Option key={item.key}>{item.value}</Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="İşlem Tipi"
              name="MonthlyPlanTypeId"
              rules={[
                {
                  required: true,
                  message: "Lütfen İşlem Tipi alanını boş bırakmayın.",
                },
              ]}
            >
              <Select
                disabled={true}
                onChange={(value, selectedObject) => {
                  var changeCheckValue =
                    selectedObject.children.toLowerCase().trim() === "çek"
                      ? false
                      : true;
                  onChangeCheck(changeCheckValue);
                }}
                showSearch
                placeholder="İşlem tipi seçiniz"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
              >
                {ManualTransactionTypeDropdown.filter(
                  (x) =>
                    x.name.toLowerCase().trim() === "çek" ||
                    x.name.toLowerCase().trim() === "senet"
                ).map((item) => (
                  <Option key={item.id}>{item.name}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Cari Adı/Ünvanı"
              name="firmId"
              rules={[
                {
                  required: true,
                  message:
                    "Lütfen Cari Adı/Ünvanı tipi alanını boş bırakmayın.",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="En az 2 harf giriniz.."
                onChange={onChangeFirmId}
                onSearch={onFirmSearch}
                filterOption={(input, option) =>
                  option.props.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                  option.code
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
                loading={firmSelect.loading}
              >
                {firmSelect.data.map((item) => (
                  <Select.Option
                    key={item.id}
                    value={item.id}
                    code={item.firmBranchNumber}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="Tckn/Vkn" name="Vkn">
              <Input
                value={Vkn}
                onChange={onChangeVkn}
                style={{ width: "100%" }}
                disabled="true"
              />
            </Form.Item>
            <Form.Item
              label="Tarih"
              name="TransactionDate"
              rules={[
                {
                  required: true,
                  message: "Lütfen Tarih alanını boş bırakmayın.",
                },
              ]}
            >
              <DatePicker
                format={"DD-MM-YYYY"}
                disabled={changeAll}
                onChange={onChangeDateValue}
                placeholder="Tarih seçiniz"
                style={{ width: "100%" }}
              />
            </Form.Item>
            <Form.Item
              label="Tutar"
              name="Amount"
              rules={[
                {
                  required: true,
                  message: "Lütfen Tutar alanını boş bırakmayın.",
                },
              ]}
            >
              <CurrencyInput
                value={Amount}
                onChange={onChangeAmount}
                className="ant-input"
                style={{ width: "100%" }}
                decimalSeparator=","
                thousandSeparator="."
              />
            </Form.Item>
            <Form.Item
              label="Para Birimi"
              name="CurrencyCode"
              initialValue="1"
              rules={[
                {
                  required: true,
                  message: "Lütfen Para Birimi alanını boş bırakmayın.",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Para birimini seçiniz"
                optionFilterProp="children"
                onChange={onChangeCurrencyValue}
                filterOption={(input, option) =>
                  option.props.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
              >
                {currencyDropdown.map((item) => (
                  <Option key={item.id}>
                    {item.code + " (" + item.symbol + ")"}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            {!checkPlan ? (
              <>
                <Form.Item label="Ödeme Yeri" name="PaymentPlace">
                  <Input
                    value={paymentPlace}
                    onChange={onChangePaymentPlace}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
                <Form.Item label="Seri No" name="SerialNo">
                  <Input
                    value={serialNo}
                    onChange={onChangeSerialNo}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
                <Form.Item
                  label="Banka Adı"
                  name="BankId"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen banka alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Seçiniz."
                    optionFilterProp="children"
                    onChange={onChangeBankId}
                    defaultValue={selectedBankDropdown}
                    filterOption={(input, option) =>
                      option.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    {bankDropdown?.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                  {/* <Input /> */}
                </Form.Item>
                <Form.Item label="Banka-Şube Kodu" name="BankBranchCode">
                  <Input
                    value={bankBranchCode}
                    onChange={onChangeBankBranchCode}
                    style={{ width: "%100" }}
                  />
                </Form.Item>
              </>
            ) : (
              <> 
              
               <Form.Item
                  label="Banka Adı"
                  name="BankId"
                >
                  <Select
                    showSearch
                    placeholder="Seçiniz."
                    optionFilterProp="children"
                    onChange={onChangeBankId}
                    defaultValue={selectedBankDropdown}
                    filterOption={(input, option) =>
                      option.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    {bankDropdown?.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                  {/* <Input /> */}
                </Form.Item>
                
               
              </>
            )}
            <Form.Item label="Satış Elemanı" name="salesmanCode">
              <Select
                allowClear
                showSearch
                placeholder="Satış Elemanı seçiniz"
                optionFilterProp="children"
                defaultValue={props.salesmanCode}
                filterOption={(input, option) =>
                  option.props.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
              >
                {salesmanCode.data.length > 0 &&
                  salesmanCode.data.map((item) => (
                    <Select.Option key={item.KOD} value={item.ACIKLAMASI}>
                      {item.ACIKLAMASI + " " + item.KOD}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Tamamlandı mı?"
              name="isCompleted"
              valuePropName="checked"
            >
              <Switch defaultChecked={isCompleted} />
            </Form.Item>
          </Col>
          <Col span={6}></Col>
          <Col span={6}></Col>
          <Col span={6}></Col>
          <Col span={6}>
            <Form.Item {...tailLayout}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Güncelle
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
export default CheckPromissoryUpdate;
